import React ,{ useState ,useEffect  } from "react" ;
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import './user.css';
import KycShell, { BrowserOnlyWarning } from '../../components/KycShell';



const User = () => {

const [message, setMessage] = useState("");
const [btnhideshow, setBtnhideshow] = useState(false);
const brandname = localStorage.getItem('brandname');
const [inputtype, setInputtype] = useState(false);
const [disabledbtn, setdisabled] = useState(false);
const [btn , setbtn] = useState("btn btn-primary");
const [btntxt , setbtntxt] = useState("Continue");
const [btnicon , setbtnicon] = useState("fa-solid fa-arrow-right");
const [isMobile, setIsMobile] = useState(false);

const checkIfMobile = () => {
    if (window.innerWidth <= 768) {
      return true;
    }
    return false;
  };

  const updateMedia = () => {
    setIsMobile(checkIfMobile());
  };
  useEffect(() => {
    updateMedia();
    window.addEventListener('resize', updateMedia);
    return () => {
      window.removeEventListener('resize', updateMedia);
    };
  }, []);

const navigate = useNavigate();

	const handleChange = (event) => {
		if(event.target.value === 'newuser')
		{
			navigate('/personal');
		}else if(event.target.value === 'exist')
		{

			setInputtype(true);
		}
	}

	const handleChangeInput = (event) => {
		if(event.target.value !== '')
		{
			setBtnhideshow(true);
		}else{
			setBtnhideshow(false);
		}
	}
	const isalreadycheck = localStorage.getItem('isalreadycheck');
	const nextpage = async ()=>{
		const document_number = document.getElementById("document_number").value;
		if(document_number !== '')
		{
			setdisabled(true);

			var uuid = localStorage.getItem('uuid');

			let data = JSON.stringify({
				"uuid": uuid,
				"document_number": document_number,
			});
			let config = {
				method: 'POST',
				mode: 'cors',
				url: '/submitdoucment',
				headers: {
					'Content-Type': 'application/json',
				},
				data : data
			};
			await axios.request(config)
			.then((response) => {

				if(response.status == 200)
				{
					if(response.data.status == 1)
					{
						localStorage.setItem('isalreadycheck', 0);
						localStorage.setItem('comImage',  response.data.comImage);
						localStorage.setItem('partial_page', 'LIVENESS');
						localStorage.setItem('kyctype', response.data.type);

						setTimeout(function(){	navigate('/kycalready') }, 500);

					}else if(response.data.status == 0)
					{
						setdisabled(false);
						setMessage(response.data.message);
					}else if(response.data.status == 3)
					{

						setMessage(response.data.message);
						setTimeout(function(){ navigate('/personal'); },5000);
					}else if(response.data.status == 4)
					{

						setMessage(response.data.message);
						setTimeout(function(){ navigate('/personal'); },5000);
					}else if(response.data.status == 2)
					{

						setMessage(response.data.message);
						setTimeout(function(){
							setMessage('');
						},5000);

						setTimeout(function(){
							setdisabled(false);
						},1000);

					}
				}else{
					setdisabled(false);
					setMessage('unauthorized access');
				}

			}).catch((error) => {
				console.log(error);
			});

		}
	}
	useEffect(() => {
	let uuids = localStorage.getItem('uuid');
	if(uuids === null)
	{
		navigate('/');
	}
	}, []);
	useEffect(() => {

	  }, [isMobile]);
    return (
		<>
			{!isMobile && <BrowserOnlyWarning />}
			{isMobile && (
				<KycShell step={1} brandName={brandname}>
					<div className="kyc-card">
						<div className="kyc-card__eyebrow">Account check</div>
						<h1 className="kyc-card__title">Check if your KYC account is already validated</h1>
						<p className="kyc-card__subtitle">
							Select whether you are a new user or if you already have a validated KYC account.
						</p>

						{message && (
							<div className="kyc-alert kyc-alert--danger" role="alert">
								<span className="kyc-alert__icon">
									<i className="fa fa-exclamation-circle" aria-hidden="true"></i>
								</span>
								<span>{message}</span>
							</div>
						)}

						<div className="kyc-field">
							<label htmlFor="type" className="kyc-label">
								Account type
							</label>
							<select
								id="type"
								onChange={handleChange}
								className="form-control selectDrop"
							>
								<option value="">Select option</option>
								<option value="newuser">New user</option>
								<option value="exist">Already KYC customer</option>
							</select>
						</div>

						{inputtype && (
							<div className="kyc-field">
								<label htmlFor="document_number" className="kyc-label">
									Enter your ID proof number
								</label>
								<input
									type="text"
									className="selectDrop"
									id="document_number"
									placeholder="Enter ID proof number"
									onChange={handleChangeInput}
								/>
							</div>
						)}

						{btnhideshow && (
							<button
								className={btn + ' btn_continue'}
								disabled={disabledbtn}
								onClick={nextpage}
								style={{ width: '100%' }}
							>
								{btntxt}
								<i className={btnicon} style={{ marginLeft: 8 }}></i>
							</button>
						)}
					</div>
				</KycShell>
			)}
		</>
);
};

export default User;
